import { SearchIcon } from 'lucide-react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

export type SearchInputProps = {
  searchName: string
  onNameChange?: (name: string) => void
  className?: string
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export function SearchInput (props: SearchInputProps) {
  const { searchName, onNameChange, size, className } = props
  const { t } = useTranslation()

  return (
    <div
      className={clsx(
        'input',
        size ? `input-${size}` : 'input-sm',
        'flex',
        'items-center',
        'gap-2',
        'font-semibold',
        'text-sm',
        'w-auto',
        searchName ? 'drawer-search-collections-input-active' : 'drawer-search-collections-input-inactive',
        className
      )}
      style={{ outline: 'unset' }}
    >
      <SearchIcon size={size ? MAP_SIZE_TO_ICON_SIZE[size] : 14} className="text-[#1C569A]" />
      <input
        autoFocus
        type="text"
        placeholder={t('Search')}
        value={searchName}
        onChange={event => onNameChange?.(event.target.value)}
        className="w-full m-0"
      />
    </div>
  )
}

const MAP_SIZE_TO_ICON_SIZE = {
  xs: 14,
  sm: 14,
  md: 16,
  lg: 16,
  xl: 16
}
